import { StateMethods } from '@hookstate/core';
import { ITag } from '@models/Tag.model';
import { SetState } from '@pages/Organization/utils/onOrgNameSubmit';

interface OnTagClickParams {
  removeTags: StateMethods<boolean>;
  selectedDelete: string[];
  tag: Pick<ITag, 'id'>;
  tags: ITag[];

  setSelectedDelete: SetState<string[]>;
  setActiveTag: SetState<ITag | undefined>;
  setOpenTagInf: SetState<boolean>;
}
function onTagClick(params: OnTagClickParams) {
  const {
    removeTags,
    selectedDelete,
    tag,
    tags,
    setSelectedDelete,
    setActiveTag,
    setOpenTagInf,
  } = params;
  return () => {
    if (removeTags.get()) {
      if (selectedDelete.find(item => item === tag.id)) {
        setSelectedDelete(selectedDelete.filter(item => item !== tag.id));
      } else {
        setSelectedDelete([...selectedDelete, tag.id]);
      }
    } else {
      setActiveTag(tags.find(item => item.id === tag.id));
      setOpenTagInf(true);
    }
  };
}

interface CalcTagProps extends Omit<OnTagClickParams, 'tag'> {
  removeTags: StateMethods<boolean>;
  selectedDelete: string[];
}
export function calcTagProps(params: CalcTagProps) {
  const { removeTags, selectedDelete } = params;
  return (tag: Pick<ITag, 'id'>) => {
    return {
      showDelete: removeTags.get(),
      deleted: !!selectedDelete.find(item => item === tag.id),
      onClick: onTagClick({
        tag,
        ...params,
      }),
      className: 'rm-m',
    };
  };
}
